import React from 'react'
import {useDragLayer} from 'react-dnd'
import Types from "components/editor_canvas/editor_canvas_element_types";
import cloneDeep from 'lodash/cloneDeep';
import EditorCanvas from "components/editor_canvas/editor_canvas";
import {PlacedItemDrag} from "components/placed_item/placed_item_view";

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    width: '100vw',
    height: '100vh',
};

function getItemStyles(initialOffset, initialPointerOffset, currentOffset, isFromThumb, bbox) {
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        }
    }
    let {x, y} = currentOffset;
    const transform = `translate(${x-bbox.left}px, ${y-bbox.top}px)`;
    return {
        transform,
        WebkitTransform: transform,
        width: '100%',
        height: '100%',
    }
}

const EditorCanvasDragLayer = (props) => {
    const {
        itemType,
        isDragging,
        item,
        initialOffset,
        initialPointerOffset,
        currentOffset,
    } = useDragLayer(monitor => ({
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        initialPointerOffset: monitor.getInitialClientOffset(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
    }));


    if (!isDragging) {
        return null
    }

    function renderItem() {
        let pitem;
        switch (itemType) {
            case Types.ELEMENT:
                pitem = EditorCanvas.defaultPlacedItem.get(item.objType);
                pitem.asset = item.asset_n;
                return <PlacedItemDrag placedItem={pitem}/>;
            default:
                return null
        }
    }

    let styles;
    let bbox = props.canvasRef.current.getBoundingClientRect();
    switch (itemType) {
        case Types.ELEMENT:
            styles = getItemStyles(initialOffset, initialPointerOffset, currentOffset, itemType === Types.ELEMENT, bbox);
            break;
    }
    return (
        <div style={{
            top: bbox.top,
            left: bbox.left,
            ...layerStyles
        }}>
            <div style={{
                position: 'relative',
                width: bbox.width,
                height: bbox.height,
            }}>
                <div style={styles}>
                    {renderItem(itemType === Types.ELEMENT)}
                </div>
            </div>
        </div>
    )
};

export default EditorCanvasDragLayer
